window.SubscriptionFunnel.StepKibble = {
  updateKibbleImageAndText(flavor) {
    const flavors = ['chicken', 'beef', 'salmon'];

    // Update select-kibble step images
    flavors.forEach(f => {
      const img = document.getElementById(`${f}-kibble-img`);
      if (img) {
        if (f === flavor) {
          img.classList.remove('display-none');
        } else {
          img.classList.add('display-none');
        }
      }
    });

    // Update kibble promo confirmation step images
    flavors.forEach(f => {
      const confirmationImg = document.getElementById(`confirmation-${f}-kibble-img`);
      if (confirmationImg) {
        if (f === flavor) {
          confirmationImg.classList.remove('display-none');
        } else {
          confirmationImg.classList.add('display-none');
        }
      }
    });

    // Update confirmation step text
    const planTextElement = document.getElementById('kibble-plan-text');
    if (planTextElement) {
      const flavorText = flavor.charAt(0).toUpperCase() + flavor.slice(1);
      planTextElement.textContent = `${flavorText} & Ancient Grains Recipe`;
    }
  }
};
